import React from 'react';
import CSSModules from 'react-css-modules';
import { generateHash } from '../../helpers/hashId';
import currencyMap from '../../helpers/currencyMap';
import styles from './WhatsAppShare.scss';
import { ShareActionOptions } from 'src/redux/modules/page';
import { isMobileUserAgent } from 'src/helpers/browser';

interface Props {
  shareByWhatsApp: (options: ShareActionOptions) => void;
  socialShareUrl: string;
  targetAmount: number;
  pitchFor: string;
  ownerName: string;
  isOwner: boolean;
  isActive: boolean;
  customStyle?: string;
  location: string;
  buttonText?: string | React.ReactNode;
  className?: string;
  targetCurrency: Currency;
  styles?: Styles;
}

class WhatsAppShare extends React.Component<Props> {
  static propTypes = {};

  handleWhatsAppShare = () => {
    const {
      location,
      ownerName,
      targetAmount,
      pitchFor,
      socialShareUrl,
      isOwner,
      targetCurrency,
      shareByWhatsApp,
    } = this.props;

    const shareHash = generateHash();
    const pageUrl = `${socialShareUrl}?utm_term=${shareHash}`;
    const target = `${currencyMap[targetCurrency] || '£'}${targetAmount}`;

    const text = isOwner
      ? `Can you help me raise ${target} to ${pitchFor}. Please donate to my JustGiving Crowdfunding Page: ${pageUrl}`
      : `Can you help ${ownerName} raise ${target} to ${pitchFor}. Please donate to their JustGiving Crowdfunding Page: ${pageUrl}`;

    shareByWhatsApp({ shareHash, location });

    if (__CLIENT__) {
      if (isMobileUserAgent()) {
        window.location.href = `whatsapp://send?text=${encodeURIComponent(
          text
        )}`;
      } else {
        window.open(
          `https://web.whatsapp.com/send?text=${encodeURIComponent(text)}`,
          '_blank'
        );
      }
    }
  };

  render() {
    const { isActive, customStyle, buttonText, className } = this.props;

    return (
      <button
        type="button"
        disabled={!isActive}
        className={className}
        styleName={customStyle}
        onClick={this.handleWhatsAppShare}
      >
        {buttonText || 'WhatsApp'}
      </button>
    );
  }
}

export default CSSModules(WhatsAppShare, styles);



// WEBPACK FOOTER //
// ./src/components/SocialShare/WhatsAppShare.tsx